import { useCurrentUserId } from "@/entities/user"
import * as m from "@/paraglide/messages"
import { showSystemPopup } from "@/shared/lib/platform"
import { useArchiveFriend, useUnarchiveFriend } from "../api/mutations"
import type { Friend } from "../model/types"

/**
 * Сценарии «Отправить в архив» / «Вернуть на главную»: системный confirm →
 * мутация → системный alert. Куда уходить после «Ок», знает экран
 * (список остаётся на месте, профиль — тоже) — передаётся колбэком.
 */
export function useArchiveFriendAction() {
	const userId = useCurrentUserId()
	const archiveFriend = useArchiveFriend()
	const unarchiveFriend = useUnarchiveFriend()

	const archive = async (friend: Friend, onDone?: () => void) => {
		const buttonId = await showSystemPopup({
			title: m.archiveConfirmTitle(),
			message: m.archiveConfirmMessage(),
			buttons: [
				{ id: "cancel", text: m.commonBtnCancel(), type: "cancel" },
				{ id: "ok", text: m.archiveConfirmBtn() },
			],
		})
		if (buttonId !== "ok") return

		archiveFriend.mutate(
			{ userId, friendId: friend.id },
			{
				onSuccess: async () => {
					await showSystemPopup({
						message: m.archiveDoneMessage(),
						buttons: [{ id: "ok", text: m.archiveBtnOk() }],
					})
					onDone?.()
				},
			},
		)
	}

	const unarchive = async (friend: Friend, onDone?: () => void) => {
		const buttonId = await showSystemPopup({
			title: m.unarchiveConfirmTitle(),
			message: m.unarchiveConfirmMessage(),
			buttons: [
				{ id: "cancel", text: m.commonBtnCancel(), type: "cancel" },
				{ id: "ok", text: m.unarchiveConfirmBtn() },
			],
		})
		if (buttonId !== "ok") return

		unarchiveFriend.mutate(
			{ userId, friendId: friend.id },
			{
				onSuccess: async () => {
					await showSystemPopup({
						message: m.unarchiveDoneMessage(),
						buttons: [{ id: "ok", text: m.archiveBtnOk() }],
					})
					onDone?.()
				},
			},
		)
	}

	return {
		archive,
		unarchive,
		isPending: archiveFriend.isPending || unarchiveFriend.isPending,
	}
}
